var map = {
	"./mine.js": "45f8",
	"./order.js": "3697",
	"./product.js": "4449",
	"./purchase.js": "3645",
	"./stat.js": "c34c",
	"./stock.js": "c1ec",
	"./supplier.js": "1853",
	"./user.js": "2963"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d56b";